import React, { FC, useCallback, useMemo } from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AsyncImage from 'components/AsyncImage/AsyncImage';
import { useLanguage } from 'context/AppContext';
import { useSet } from 'hooks/useSet';
import { StorageType } from 'utils/helpers/image.helpers';
import * as Styles from '../DraftTile.styles';

interface SetDraftTileProps {
  code: string;
}

export const SetDraftTile: FC<SetDraftTileProps> = ({ code }) => {
  const navigate = useNavigate();
  const [language] = useLanguage();
  const { set, loading } = useSet(code, false, false);
  const trayRef = useMemo(() => {
    try {
      return Object.values(set.trays)[0].reference;
    } catch (error) {
      return undefined;
    }
  }, [set.trays]);

  const handleClick = useCallback(() => {
    navigate(`/set/${set.code}/edit`);
  }, [navigate, set.code]);

  return (
    <Styles.DraftTileButton onClick={handleClick}>
      <Styles.DraftTileContent>
        {!loading && (
          <Styles.DraftTileStatus status={set.status} className="tile-status">
            {language.SetStatus[set.status]}
          </Styles.DraftTileStatus>
        )}
        <Styles.DraftTileImage>
          <AsyncImage
            setCode={set.code}
            trayRef={trayRef}
            alt={code}
            imgWidth={18}
            imgHeight={11}
            storageType={StorageType.DRAFT}
          />
        </Styles.DraftTileImage>
        <Styles.DraftTileName>
          <Typography component="strong">{set.display_code}</Typography>
          <Typography sx={{ 'text-transform': 'none' }}>{set.owner_email}</Typography>
        </Styles.DraftTileName>
      </Styles.DraftTileContent>
    </Styles.DraftTileButton>
  );
};
